import React from 'react';
import { TextFeature } from '../types';
import AppFeatures from '../components/Views/AppFeatures';
import WorkHistory from '../components/Views/WorkHistory';
import Contact from '../components/Views/Contact';
import Hero from '../components/Views/Hero';

const textFeatures: TextFeature[] = [
  {
    id: 'work-history',
    title: 'Work History',
    content: '' // Content is now handled by the WorkHistory component
  },
  {
    id: 'contact',
    title: 'Contact',
    content: '' // Content is now handled by the Contact component
  },
];

const Kindred: React.FC = () => {

  return (
    <div className="min-h-screen mt-2 sm:mt-12 bg-white text-black">
      {/* Content Column */}
      <div className="w-full max-w-[55rem] py-8 px-4 mx-auto">
        {/* Hero Section with Image */}
        <section className="mb-16">
          <Hero heroSubtitle={"n/a"} isKindred={true} />

          <div className="mt-8">
            <h2 className="text-lg font-light text-black mb-4">Who is Theo?</h2>
            <div className="text-gray-600 pl-4 sm:pl-0">
              <p className="mb-4 text-md">I am a multi-disciplinary product manager with a passion for building products that delight users. </p>
              <p className="mb-4 text-md">Becoming a product manager wasn't my childhood dream. I just liked building things. Legos and lemonade stands evolved into carpentry, houseplants and eventually digital products. </p>
              <p className="mb-4 text-md">I'm comfortable talking to users. Working with designers. Looking at code. Telling stories with data.</p>
              <p className="mb-4 text-md">Now I'm looking for my next challenge. One where I can combine product, technology, travel & humanity to craft great products. I'd love to bring my skills to Kindred, and help make a better world for people to live and travel in.</p>
            </div>
          </div>
          
        </section>

        {/* Stats Section */}
        <section className="mb-16 ">
          <div className="grid grid-cols-2 lg:grid-cols-4 sm:gap-4 divide-x divide-y divide-white">
            {[
              { label: 'Years since moving to Boulder', value: '1.5' },
              { label: 'Countries visited', value: '28' },
              { label: 'Years since I was born', value: '37' },
              { label: 'Age of my son, Luca', value: '2' },
            ].map((stat, index) => (
              <div key={index} className="bg-gray-100 p-4 sm:rounded-2xl">
                <p className="text-2xl text-center text-black min-h-7">{stat.value || '\u00A0'}</p>
                <p className="text-sm text-center text-gray-500 min-h-5">{stat.label || '\u00A0'}</p>
              </div>
            ))}
          </div>
        </section>

        {/* What I Bring Section */}
        <section className="mb-16">
        <h3 className="text-lg font-light text-black mb-4">What I Bring to the Table</h3>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {[
              { label: 'Experience', value: 'I have 10+ years of experience in PM. I\'ve led 0->1 products, and a consumer marketplace app.' },
              { label: 'Founder Mindset', value: 'Shipped several side projects from mobile apps to SaaS products.' },
              { label: 'Love of Design', value: 'Figma doesnt scare me. Neither does analytics. Whatever it takes to deliver great UX.' },
              { label: 'B2C Passion', value: 'I love consumer apps & talking to real users. This is my calling. I\'m a B2C PM.' },
              { label: 'Veteran Traveller', value: 'I lived in 12 countries in 12 months with my wife. Working remotely the whole time.' },
              { label: 'Big Picture Thinker, Good with Details', value: 'I stay stubborn on the vision, loose on the details.' },
            ].map((stat, index) => {
              const pastelBg = [
                'bg-rose-50', 'bg-amber-50', 'bg-emerald-50', 'bg-sky-50', 'bg-indigo-50', 'bg-violet-50',
              ][index % 6];
              return (
                <div key={index} className={`rounded-2xl border border-gray-200 p-4 ${pastelBg}`}>
                  <p className="text-2xl font-light text-black min-h-7 mb-4">{stat.label || '\u00A0'}</p>
                  <p className="text-sm text-gray-600 min-h-5">{stat.value || '\u00A0'}</p>
                </div>
              );
            })}
          </div>
        </section>

        {/* Featured Section */}
        <section className="mb-16">
          <div className="space-y-12">
            {textFeatures.map((feature) => (
              <div key={feature.id}>
                <h3 className="text-lg font-light text-black mb-4">{feature.title}</h3>
                <div className={`rounded-lg ${feature.id === 'work-history' ? 'pl-0 pr-0' : 'pl-4 sm:pl-0'}`}>
                  {feature.id === 'work-history' ? (
                    <>
                      <WorkHistory />
                      <AppFeatures />
                    </>
                  ) : feature.id === 'contact' ? (
                    <Contact />
                  ) : (
                    <p className="text-black text-left">
                      {feature.content}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        <footer className="mb-12">
          <p className="text-sm text-gray-500">
            This site was <strong>created exclusively for this Kindred position,</strong> so you should know, I’m very excited you’re here! 🎉
          </p>
        </footer>
      </div>
    </div>
  );
};

export default Kindred;